<template>
  <div style="position: relative;">
    <Tab class="tab" ref="Tab" :tabIdx="tabIdx" :data="tabData" @onToggleTab="onToggleTab">
      <template #default>
        <el-row>
          <div class="box">
            <DataModal :data="data" :carData="carData" />

            <div style="height:20px;"></div>

            <div class="totData">
              <div class="Dscreen" style="margin:0 auto 20px;">
                <div class="itema">
                  <div class="info">
                    <h3>利润额</h3>
                    <div class="ps reallyprofit">{{ orderProfit.reallyprofit }}</div>
                  </div>
                </div>
                <div class="itema">
                  <div class="info">
                    <h3>当前差额</h3>
                    <div class="ps ">
                      <div class="per diffprofit">{{ orderProfit.diffprofit }}</div>
                    </div>
                  </div>
                </div>
                <div class="itema">
                  <div class="info">
                    <h3>利润目标</h3>
                    <div class="ps allprofit">{{ orderProfit.allprofit }}</div>
                  </div>
                </div>
              </div>

              <div class="vehdatalist allprofitlist">
                <div class="vehitem" v-for="(v, i) in orderProfit.car" :key="'vitem' + i" @click="showDetail(v)">
                  <div class="name">{{ v.license }}</div>
                  <div class="vehbar">
                    <div class="bg" ref="wholebar">
                      <div class="value0" ref="labelbar">{{ v.reallyfreight }}</div>
                      <div ref="conbar" class="bga" :data-num="v.reallyfreight / v.targetfreight"></div>
                      <div ref="erect" class="erect" :class="v.difffreight > 0 ? 'erecta' : ''" style="left:77px;"
                        :data-num="v.normalfreight / v.targetfreight"></div>
                      <div ref="value1" class="value1" style="left:90px;">{{ `${v.difffreight > 0 ? '+' :
      ''}${v.difffreight}`
                        }}
                      </div>
                    </div>
                    <div class="value2">{{ v.targetfreight }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 第二列 -->
          <div class="box" style="margin: 0 0.5%;">
            <div class="totData">
              <div class="Dscreen" style="margin:0 auto 20px;">
                <div class="itema">
                  <div class="info">
                    <h3>营业额</h3>
                    <div class="ps">{{ order.allfreight }}</div>
                  </div>
                </div>
                <div class="itema">
                  <div class="info">
                    <h3>当前差额</h3>
                    <div class="ps">
                      <div class="per">{{ order.chaallfreight }}</div>
                    </div>
                  </div>
                </div>
                <div class="itema">
                  <div class="info">
                    <h3>本月目标</h3>
                    <div class="ps">{{ order.targetfreight }}</div>
                  </div>
                </div>
              </div>

              <div class="vehdatalist allfreightlist">
                <div class="vehitem" v-for="(v, i) in order.car2" :key="'v2item' + i" @click="showDetail(v)">
                  <div class="name">{{ v.license }}</div>
                  <div class="vehbar">
                    <div class="bg" ref="wholebar">
                      <div class="value0" ref="labelbar">{{ v.reallyfreight }}</div>
                      <div ref="conbar" class="bga" :data-num="v.reallyfreight / v.targetfreight"></div>
                      <div ref="erect" class="erect" :class="v.difffreight > 0 ? 'erecta' : ''" style="left:77px;"
                        :data-num="v.normalfreight / v.targetfreight"></div>
                      <div ref="value1" class="value1" style="left:90px;">{{ `${v.difffreight > 0 ? '+' :
      ''}${v.difffreight}`
                        }}
                      </div>
                    </div>
                    <div class="value2">{{ v.targetfreight }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 第三列 -->
          <div class="box">
            <div class="totData">
              <div class="Dscreen">
                <div class="item">
                  <div class="info">
                    <h3>完成订单</h3>
                    <div class="ps">{{ carOrder.count4 }}</div>
                  </div>
                  <i></i>
                </div>
                <div class="item">
                  <div class="info">
                    <h3>平均运费</h3>
                    <div class="ps">
                      <div class="per pers">{{ carOrder.avefreight }}</div>
                    </div>
                  </div>
                  <i></i>
                </div>
                <div class="item">
                  <div class="info">
                    <h3>平均单价</h3>
                    <div class="ps">{{ carOrder.aveprice }}</div>
                  </div>
                  <i></i>
                </div>
                <div class="item">
                  <div class="info">
                    <h3>在途订单</h3>
                    <div class="ps">{{ carOrder.count }}</div>
                  </div>
                </div>
              </div>

              <div class="vehSheet">
                <div class="top">
                  <div class="th">车牌号</div>
                  <div class="th">完成订单</div>
                  <div class="th">平均运费</div>
                  <div class="th">平均单价</div>
                  <div class="th">在途订单</div>
                  <div class="th">金额</div>
                </div>
                <div class="listb listd">
                  <div class="item" v-for="(v, i) in carOrder.car3" :key="'v3item' + i">
                    <div class="td">{{ v.license }}</div>
                    <div class="td">{{ v.count4 }}</div>
                    <div class="td">
                      <div class="per" :class="v.avefreight - Number(carOrder.avefreight) < 0 ? 'pera' : ''">{{ v.avefreight
                        }}
                      </div>
                    </div>
                    <div class=" td">
                      <div class="per" :class="v.avecprice - Number(carOrder.aveprice) < 0 ? 'pera' : ''">{{ v.avecprice }}
                      </div>
                    </div>
                    <div class="td">{{ v.iscount }}</div>
                    <div class="td">{{ v.isorderfreight }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-row>
      </template>
    </Tab>

    <el-button class="exportBtn" type="primary" size="small" :loading="btnloading" @click="getExport">
      <i v-if="!btnloading" class="el-icon-folder"></i>
      导出
    </el-button>

    <Dialog class="dialog" ref="dialog" :title="title">
      <template #default>
        <DataModal :data="detail" :showDay="true" />
      </template>
    </Dialog>
  </div>
</template>

<script>
export default {
  name: "DataCenter",
  data() {
    return {
      baseUrl: 'cartarget',
      tabIdx: 0,
      tabData: [
        { name: '全部', value: 0 },
      ],
      data: {},
      carData: {},
      orderProfit: {},
      order: {},
      carOrder: {},
      title: '单车信息',
      detail: {},
      btnloading: false,
      tar_w: 0,
    };
  },
  methods: {
    getExport() {
      this.btnloading = true
      let url = `${this.baseUrl}/getmyexcel`;
      const params = {
        // userid: this.user.id,
      }
      this.post(url, params, (res) => {
        const { msg, excel } = res
        if (msg === 'success' && excel) {
          console.log(res)
          var link = document.createElement('a')
          link.href = excel
          link.download = "运营分析表"
          link.click()
        } else {
          this.$message({
            type: 'error',
            message: '导出失败，请稍后再试！',
          });
        }
        this.btnloading = false
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    onToggleTab({ index }) {
      // this.tabIdx = index;
      console.log(index)
      this.getPageData({ fleet: this.tabData[index].value });
    },
    getRound(num) {
      return (Math.round(num * 100) / 100)
    },
    getPercent(n = 0, m) {
      return Math.round(n / m * 1000) / 10 + '%'
    },
    getGrowth(n, m) {
      if (n < m) {
        return '-' + this.getRound(m - n)
      } else {
        return '+' + this.getRound(n - m)
      }
    },
    getTabData() {
      this.loading = true
      let url = `${this.baseUrl}/myfleet`;
      const params = {
        // userid: this.user.id,
      }
      this.post(url, params, (res) => {
        const { msg, team } = res
        if (msg === 'success' && team) {
          // console.log(res)
          team.map(v => {
            const obj = {
              name: v.nickname,
              value: v.id,
            }
            this.tabData.push(obj)
          })
          this.$nextTick(() => {
            this.$refs.Tab.refresh()
          })
        } else {
          this.$message({
            type: 'error',
            message: '加载失败，请稍后再试！',
          });
        }
        this.loading = false
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    getPageData(params = {}) {
      this.loading = true
      let url = `${this.baseUrl}/cartarget`;
      this.post(url, params, (res) => {
        const { msg } = res
        if (msg === 'success') {
          // console.log(1,res)
          this.data = { ...this.data, ...res }
        } else {
          this.$message({
            type: 'error',
            message: '加载失败，请稍后再试！',
          });
        }
        this.loading = false
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })

      this.getCarData(params)
      this.getOrderData(params)
      this.getOrder(params)
      this.getCarOrder(params)
    },
    getCarData(params = {}) {
      this.loading = true
      let url = `${this.baseUrl}/carfleet`;
      this.post(url, params, (res) => {
        const { msg } = res
        if (msg === 'success') {
          // console.log(res)
          this.carData = { ...this.carData, ...res }
        } else {
          this.$message({
            type: 'error',
            message: '加载失败，请稍后再试！',
          });
        }
        this.loading = false
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    getOrderData(params = {}) {
      this.loading = true
      let url = `${this.baseUrl}/getorderprofit`;
      this.post(url, params, (res) => {
        const { msg, data } = res
        if (msg === 'success') {
          console.log(res)
          this.orderProfit = { ...this.orderProfit, ...data }
          // console.log(this.data)
          this.setBarWidth()
        } else {
          this.$message({
            type: 'error',
            message: '加载失败，请稍后再试！',
          });
        }
        this.loading = false
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    setBarWidth() {
      this.$nextTick(() => {
        // console.log(this.$refs.labelbar[0])
        if (!this.$refs.labelbar || !this.$refs.labelbar[0]) return;
        const value0_w = this.$refs.labelbar[0].offsetWidth
        const tar_w = this.$refs.wholebar[0].offsetWidth - value0_w
        // console.log(tar_w)
        if (tar_w > 0) {
          this.tar_w = tar_w
        }
        // console.log(this.$refs.conbar)
        this.$refs.conbar.map(v => {
          if (v.dataset.num > 0) {
            v.style.width = this.tar_w * v.dataset.num + 'px'
          } else {
            v.style.width = '1px'
          }
        })
        this.$refs.erect.map((v, i) => {
          if (v.dataset.num > 0) {
            v.style.left = this.tar_w * v.dataset.num + 60 + 'px'
          }
          if (v.dataset.num < 0.8) {
            this.$refs.value1[i].style.left = this.tar_w * v.dataset.num + 73 + 'px'
          } else {
            this.$refs.value1[i].style.left = this.tar_w * v.dataset.num + 18 + 'px'
          }
        })
      })
    },
    getOrder(params = {}) {
      this.loading = true
      let url = `${this.baseUrl}/getorder`;
      this.post(url, params, (res) => {
        const { msg, reight, car } = res
        if (msg === 'success') {
          // console.log(car)
          this.order = { ...reight, car2: car }
          // console.log(this.data)
          this.setBarWidth()
        } else {
          this.$message({
            type: 'error',
            message: '加载失败，请稍后再试！',
          });
        }
        this.loading = false
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    getCarOrder(params = {}) {
      this.loading = true
      let url = `${this.baseUrl}/getcarorder`;
      this.post(url, params, (res) => {
        const { msg, reight, car } = res
        if (msg === 'success') {
          // console.log(car)
          this.carOrder = { ...reight, car3: car }
        } else {
          this.$message({
            type: 'error',
            message: '加载失败，请稍后再试！',
          });
        }
        this.loading = false
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    getSingleCar(params = {}) {
      let url = `${this.baseUrl}/getbicyclecar`;
      this.post(url, params, (res) => {
        const { msg, car, data, monthday, nowtime, targetfreight, weekday, day } = res
        if (msg === 'success') {
          // console.log(car)
          this.detail = { ...car, ...data, monthday, nowtime, targetfreight, weekday, day }
          // console.log({ ...this.detail })
        } else {
          this.$message({
            type: 'error',
            message: '加载失败，请稍后再试！',
          });
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    showDetail({ id }) {
      this.getSingleCar({ carid: id })
      this.showDialog()
    },
    showDialog(str = 'dialog') {
      this.$refs[str] && this.$refs[str].show()
    },
  },
  mounted() {
    this.getTabData()
    this.getPageData()
  },
};
</script>

<style lang="less" scoped>
.box {
  width: 33%;
  float: left;
}

.todpro {
  height: auto;
  overflow: hidden;
  margin: 0 auto 20px;
  border-radius: 10px;
  background: linear-gradient(270deg, #00CF9E 0%, #2691FF 100%);

  .item {
    float: left;
    width: 32%;
    height: auto;
    overflow: hidden;
    margin: 0 0 0 1%;

    .info {
      height: auto;
      overflow: hidden;
      margin: 0 auto;
      border-right: 1px solid rgba(255, 255, 255, 0.23);

      h3 {
        height: auto;
        overflow: hidden;
        margin: 20px auto;
        text-align: center;
        line-height: 19px;
        font-size: 14px;
        color: #fff;
        opacity: 0.8;
      }

      p {
        height: auto;
        overflow: hidden;
        margin: 0 auto 20px;
        text-align: center;
        line-height: 29px;
        font-size: 22px;
        color: #fff;
      }
    }

    &:first-child {
      .info {
        h3 {
          opacity: 1;
        }
      }
    }
  }
}

.totData {
  height: auto;
  overflow: hidden;
  margin: 0 auto;
  padding: 20px 20px 0;
  border-radius: 10px;
  box-shadow: 0px 0px 10px rgb(0 0 0 / 4%);
  background: #fff;

  .list {
    height: auto;
    overflow: hidden;
    margin: 0 auto;

    .item {
      border-radius: 8px;
      background: #F9F9F9;

      .fltit {
        float: left;
        height: 22px;
        line-height: 22px;
        overflow: hidden;
        font-weight: bold;
        font-size: 15px;
        color: #303133;

        .ico {
          float: left;
          width: 5px;
          height: 22px;
          overflow: hidden;
          margin: 0 15px 0 0;
        }

        .ico1 {
          background: #2691FF;
        }

        .ico2 {
          background: #F56C6C;
        }

        .ico3 {
          background: #00C7F0;
        }

        .ico4 {
          background: #92D050;
        }

        .ico5 {
          background: #FFC000;
        }
      }

      .per {
        float: right;
        height: 20px;
        line-height: 20px;
        overflow: hidden;
        padding: 0 13px 0 0;
        font-size: 15px;
        color: #606266;
        background: url(../assets/img/icon_totper_01.png) no-repeat right center;
        background-size: 8px;
      }

      .pera {
        background: url(../assets/img/icon_totper_02.png) no-repeat right center;
        background-size: 8px;
      }

      .pers {
        background: none;
      }

      .nums {
        height: auto;
        overflow: hidden;
        margin: 18px 19px 20px;

        .fla {
          float: left;
          height: 29px;
          line-height: 29px;
          overflow: hidden;
          font-size: 22px;
          color: #303133;
        }

        .flb {
          float: left;
          height: 19px;
          line-height: 19px;
          overflow: hidden;
          margin: 10px 0 0 5px;
          font-size: 14px;
          color: #909399;
        }
      }
    }

    &.lista .item {
      float: left;
      width: 48%;
      height: auto;
      overflow: hidden;
      margin: 0 4% 15px 0;

      .top {
        height: auto;
        overflow: hidden;
        margin: 20px 20px 0 0;
      }

      &.item:nth-child(2n) {
        margin: 0 0 15px 0;
      }
    }

    &.listb .item {
      height: auto;
      overflow: hidden;
      margin: 0 auto 15px;

      .flcon {
        position: relative;
        float: left;
        width: 25%;
        height: auto;
        overflow: hidden;

        .info {
          margin: 0 1px 0 0;
          height: auto;
          overflow: hidden;

          .top {
            height: auto;
            overflow: hidden;
            margin: 19px 0 0 0;
          }

          .topa {
            height: 20px;
            line-height: 20px;
            overflow: hidden;
            margin: 25px auto 20px;
            text-align: center;
            font-size: 15px;
            color: #303133;
          }

          .ptit {
            height: auto;
            line-height: 20px;
            overflow: hidden;
            margin: 0 auto 25px;
            text-align: center;
            font-size: 14px;
            color: #909399;
          }

          .per {
            float: none;
            display: inline-block;
          }
        }

        i {
          display: block;
          position: absolute;
          right: 0;
          top: 33px;
          width: 1px;
          height: 42px;
          overflow: hidden;
          background: rgba(0, 0, 0, 0.06);
        }
      }

      .nums .flb {
        margin: 10px 5px 0 0;
      }
    }
  }

  .Dscreen {
    height: auto;
    overflow: hidden;
    margin: 0 auto 30px;
    border-radius: 7px;
    background: #F5F5F5;

    .itema {
      float: left;
      width: 32%;
      height: auto;
      overflow: hidden;
      margin: 0 0 0 1%;

      .info {
        height: auto;
        overflow: hidden;
        margin: 0 auto;
        border-right: 1px solid rgba(0, 0, 0, 0.05);

        h3 {
          height: 19px;
          line-height: 19px;
          overflow: hidden;
          margin: 20px 0 20px 20px;
          font-size: 14px;
          color: #606266;
        }

        .ps {
          height: 29px;
          line-height: 29px;
          overflow: hidden;
          margin: 0 0 20px 20px;
          font-size: 22px;
          color: #303133;
        }
      }
    }

    .item {
      position: relative;
      float: left;
      width: 25%;
      height: auto;
      overflow: hidden;

      .info {
        height: auto;
        overflow: hidden;
        margin: 0 1px 0 0;

        h3 {
          height: 19px;
          line-height: 19px;
          text-align: center;
          overflow: hidden;
          margin: 20px auto;
          font-size: 14px;
          color: #606266;
        }

        .ps {
          height: 29px;
          line-height: 29px;
          text-align: center;
          overflow: hidden;
          margin: 0 auto 20px;
          font-size: 22px;
          color: #303133;
        }
      }

      i {
        display: block;
        position: absolute;
        right: 0;
        top: 33px;
        width: 1px;
        height: 42px;
        overflow: hidden;
        background: rgba(0, 0, 0, 0.05);
      }
    }
  }

  .vehdatalist {
    height: auto;
    overflow: hidden;
    margin: 0 auto;

    .vehitem {
      height: auto;
      overflow: hidden;
      margin: 0 auto 20px;
      cursor: pointer;

      .name {
        height: 20px;
        line-height: 20px;
        overflow: hidden;
        margin: 0 auto 10px;
        font-size: 15px;
        color: #303133;
      }

      .vehbar {
        position: relative;
        height: auto;
        overflow: hidden;
        margin: 0 auto;

        .bg {
          position: relative;
          margin: 0 75px 0 0;
          height: 39px;
          overflow: hidden;
          border-radius: 3px;
          background: #F5F5F5;

          .value0 {
            position: absolute;
            left: 0;
            top: 0;
            width: 62px;
            height: 39px;
            line-height: 39px;
            text-align: center;
            overflow: hidden;
            font-size: 14px;
            color: #303133;
          }

          .bga {
            position: absolute;
            left: 62px;
            top: 4px;
            height: 31px;
            overflow: hidden;
            border-radius: 3px;
            background: #2691FF;
            width: 1px;
          }

          .erect {
            position: absolute;
            left: 0;
            top: 0;
            width: 3px;
            height: 37px;
            overflow: hidden;
            border-radius: 1px;
            border: 1px solid #fff;
            background: #67C23A;
            box-shadow: 0px 0px 6px rgb(0 0 0 / 16%);
          }

          .erecta {
            background: #F56C6C;
          }

          .value1 {
            position: absolute;
            left: 0;
            top: 0;
            width: auto;
            height: 39px;
            line-height: 39px;
            text-align: center;
            overflow: hidden;
            font-size: 12px;
            color: #303133;
          }
        }

        .value2 {
          position: absolute;
          right: 0;
          top: 0;
          width: 74px;
          height: 39px;
          line-height: 39px;
          text-align: center;
          overflow: hidden;
          font-size: 14px;
          color: #C0C4CC;
        }
      }
    }
  }

  .vehSheet {
    height: auto;
    overflow: hidden;
    margin: 0 auto 5px;

    .top {
      height: auto;
      overflow: hidden;
      margin: 0 auto 15px;

      .th {
        float: left;
        width: 15.5%;
        height: 19px;
        line-height: 19px;
        text-align: center;
        overflow: hidden;
        margin: 0 0 0 1%;
        font-size: 14px;
        color: #909399;
      }
    }

    .listb {
      height: auto;
      overflow: hidden;
      margin: 0 auto;

      .item {
        height: auto;
        overflow: hidden;
        margin: 0 auto 15px;
        border-radius: 5px;
        background: #F5F5F5;

        .td {
          float: left;
          width: 15.5%;
          height: 47px;
          line-height: 47px;
          text-align: center;
          overflow: hidden;
          margin: 0 0 0 1%;
          font-size: 14px;
          color: #909399;
        }

        .per {
          display: inline-block;
          width: auto;
          padding: 0 13px 0 0;
          height: 20px;
          line-height: 20px;
          overflow: hidden;
          margin: 13px auto 0;
          font-size: 15px;
          color: #606266;
          background: url(../assets/img/icon_totper_01.png) no-repeat right center;
          background-size: 8px;
        }

        .pera {
          background: url(../assets/img/icon_totper_02.png) no-repeat right center;
          background-size: 8px;
        }
      }
    }
  }
}

.dialog /deep/ .el-dialog {
  width: 40%;
  margin-top: 20px !important;
  margin-bottom: auto;
}

.tab {
  margin: 1px;

  &.tab-page {
    /deep/.el-tabs__header {
      padding: 0;
      margin-bottom: 30px;

      .el-tabs__nav-wrap::after {
        width: 100%;
      }
    }
  }

}

.exportBtn {
  position: absolute !important;
  top: 0px;
  right: 20px;
  // width: 78px;
  // height: 29px;
  // background: url(../assets/img/daochu.png) no-repeat right center;
  // background-size: 78px 29px;
}
</style>
